import React from 'react';
import Select from 'react-select';

export interface SelectOption {
    value: string;
    label: string;
}

interface SelectInputProps {
    inputId: string;
    value: SelectOption | null;
    onChange: (option: SelectOption | null) => void;
    options: SelectOption[];
    placeholder?: string;
    isClearable?: boolean;
    isSearchable?: boolean;
    isDisabled?: boolean;
    hasError?: boolean;
    className?: string;
}

export const SelectInput: React.FC<SelectInputProps> = ({
    inputId,
    value,
    onChange,
    options,
    placeholder = 'Select an option',
    isClearable = false,
    isSearchable = true,
    isDisabled = false,
    hasError = false,
    className = ''
}) => {
    return (
        <Select<SelectOption>
            inputId={inputId}
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            isClearable={isClearable}
            isSearchable={isSearchable}
            isDisabled={isDisabled}
            className={hasError ? `is-invalid ${className}` : className}
            styles={{
                control: (base: any) => ({
                    ...base,
                    borderColor: hasError ? '#dc3545' : base.borderColor,
                    '&:hover': {
                        borderColor: hasError ? '#dc3545' : base['&:hover']?.borderColor,
                    }
                })
            }}
        />
    );
};
